/*! @pentacode/ui v0.1.0 */
import { S as e, a as t, i as n, n as r, o as i, w as a, x as o, y as s } from "./guide-layout-CM2GPEJu.js";
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/configured-scale.js
function c(e, t) {
	let n = a(e, {
		values: t.values,
		includeZero: t.includeZero,
		nice: t.options?.nice,
		niceCount: t.tickCount
	}), r = p(n.domain()), i = l(n, t, r), o = n.bandwidth !== void 0, s = o && t.channel === "y" ? [Math.min(...t.range), Math.max(...t.range)] : t.range, c = t.options?.reverse ? [s[1], s[0]] : s;
	n = n.range(c);
	let u = p(n.domain());
	if (i && (!d(u, i.domain) || !f(n, i.domain, c))) throw TypeError(`Chart viewport "${t.id}" requires independent configurable domain and range capabilities`);
	let m = t.options?.axis === !1 ? void 0 : t.options?.axis?.ticks, h = m === !1 ? void 0 : m, g = h?.values ?? n.ticks?.(t.tickCount) ?? u, _ = n.tickFormat?.(t.tickCount), v = n.bandwidth?.() ?? 0, y = (e) => {
		let t = n(e);
		return t === void 0 ? NaN : t + v / 2;
	}, b = n.invert ? (e) => n.invert(e - v / 2) : void 0;
	return {
		id: t.id,
		type: o ? "band" : "configured",
		domain: u,
		map: y,
		...b ? { invert: b } : {},
		ticks: g.map((e) => ({
			value: e,
			position: y(e),
			label: h?.format?.(e) ?? _?.(e) ?? x(e)
		})),
		bandwidth: v,
		...i ? { viewport: {
			contentDomain: r,
			domain: i.domain,
			translate: i.translate,
			map: (e) => y(e) + i.translate
		} } : {}
	};
}
function l(e, t, n) {
	let r = t.options?.viewport;
	if (!r) return;
	let i = e;
	if (e.bandwidth !== void 0 || typeof e.ticks != "function" || typeof i.invert != "function") throw TypeError(`Chart viewport "${t.id}" requires a continuous numeric or temporal scale`);
	if (typeof i.clamp == "function" && i.clamp() === !0) throw TypeError(`Chart viewport "${t.id}" does not support a clamped scale`);
	let a = r.domain;
	a.length === 2 && _(a[0], a[1]) || b(t.id);
	let o = v(a[0]), s = v(a[1]);
	Number.isFinite(o) && Number.isFinite(s) && o !== s || b(t.id), h(e, t.id, n, a);
	let c = r.translate ?? 0;
	if (!Number.isFinite(c)) throw TypeError(`Chart viewport "${t.id}" translate must be a finite number`);
	d(e.domain(), a) && u(e, [a[1], a[0]], t.id), u(e, a, t.id);
	let l = p(e.domain());
	return l.length === 2 && _(l[0], l[1]) || m(t.id), {
		domain: l,
		translate: c
	};
}
function u(e, t, n) {
	let r = e.domain;
	try {
		r.call(e, [...t]);
	} catch {
		m(n);
	}
	d(e.domain(), t) || m(n);
}
function d(e, t) {
	return e.length === t.length && e.every((e, n) => y(e, t[n]));
}
function f(e, t, n) {
	let r = e(t[0]), i = e(t[1]);
	return r !== void 0 && i !== void 0 && Number.isFinite(r) && Number.isFinite(i) && Math.abs(r - n[0]) <= 1e-6 && Math.abs(i - n[1]) <= 1e-6;
}
function p(e) {
	return e.map((e) => e instanceof Date ? new Date(e.getTime()) : e);
}
function m(e) {
	throw TypeError(`Chart viewport "${e}" requires a scale with a configurable domain`);
}
function h(t, n, r, i) {
	if (!e(t)) return;
	let a = g(r), o = g(i);
	if (a === void 0 || o === void 0 || a !== o) throw TypeError(`Chart viewport "${n}" logarithmic content and viewport domains must be finite, nonzero, and stay on the same side of zero`);
}
function g(e) {
	let t;
	for (let n of e) {
		if (typeof n != "number" || !Number.isFinite(n) || n === 0) return;
		let e = Math.sign(n);
		if (t !== void 0 && e !== t) return;
		t = e;
	}
	return t;
}
function _(e, t) {
	return typeof e == "number" && typeof t == "number" || e instanceof Date && t instanceof Date;
}
function v(e) {
	return e instanceof Date ? e.getTime() : e;
}
function y(e, t) {
	return e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : Object.is(e, t);
}
function b(e) {
	throw TypeError(`Chart viewport "${e}" domain must contain two distinct finite numbers or Dates`);
}
function x(e) {
	return e instanceof Date ? e.toLocaleDateString() : String(e);
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/renderer-rect.js
function S(e, t, n) {
	let [r, i, a, o] = e ?? [
		0,
		0,
		0,
		0
	], s = [
		w(r),
		w(i),
		w(a),
		w(o)
	], c = T(t), l = T(n), u = Math.min(1, E(c, s[0] + s[1]), E(c, s[3] + s[2]), E(l, s[0] + s[3]), E(l, s[1] + s[2]));
	return u === 1 ? s : [
		s[0] * u,
		s[1] * u,
		s[2] * u,
		s[3] * u
	];
}
function C(e, t, n, r, i) {
	let a = D(e, t, n, r), [o, s, c, l] = S(i, a.width, a.height), u = a.x, d = a.y, f = u + a.width, p = d + a.height;
	return [
		`M${O(u + o)},${O(d)}`,
		`H${O(f - s)}`,
		`A${O(s)},${O(s)} 0 0 1 ${O(f)},${O(d + s)}`,
		`V${O(p - c)}`,
		`A${O(c)},${O(c)} 0 0 1 ${O(f - c)},${O(p)}`,
		`H${O(u + l)}`,
		`A${O(l)},${O(l)} 0 0 1 ${O(u)},${O(p - l)}`,
		`V${O(d + o)}`,
		`A${O(o)},${O(o)} 0 0 1 ${O(u + o)},${O(d)}`,
		"Z"
	].join("");
}
function w(e) {
	return Number.isFinite(e) && e > 0 ? e : 0;
}
function T(e) {
	return Number.isFinite(e) ? Math.abs(e) : 0;
}
function E(e, t) {
	return t === 0 ? 1 : e / t;
}
function D(e, t, n, r) {
	let i = e + n, a = t + r;
	return {
		x: Math.min(e, i),
		y: Math.min(t, a),
		width: Math.abs(n),
		height: Math.abs(r)
	};
}
function O(e) {
	return String(Math.round(e * 100) / 100);
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/rect-radius-internal.js
var k = Math.PI * 2;
function A(e, t, n, r, i, a, o) {
	let s = M(e, t, n, r), c = s.x, l = s.y, u = c + s.width, d = l + s.height;
	if (!(a >= c && a <= u && o >= l && o <= d)) return !1;
	let [f, p, m, h] = S(i, s.width, s.height);
	return a < c + f && o < l + f ? N(a, o, c + f, l + f, f) : a > u - p && o < l + p ? N(a, o, u - p, l + p, p) : a > u - m && o > d - m ? N(a, o, u - m, d - m, m) : a < c + h && o > d - h ? N(a, o, c + h, d - h, h) : !0;
}
function j(e, t, n, r, i, a, o) {
	if (A(e, t, n, r, i, a, o)) return 0;
	let s = M(e, t, n, r), c = s.x, l = s.y, u = c + s.width, d = l + s.height, [f, p, m, h] = S(i, s.width, s.height);
	return Math.min(F(c + f, l, u - p, l, a, o), F(u, l + p, u, d - m, a, o), F(u - m, d, c + h, d, a, o), F(c, d - h, c, l + f, a, o), P(a, o, c + f, l + f, f, Math.PI, Math.PI * 1.5), P(a, o, u - p, l + p, p, Math.PI * 1.5, k), P(a, o, u - m, d - m, m, 0, Math.PI * .5), P(a, o, c + h, d - h, h, Math.PI * .5, Math.PI));
}
function M(e, t, n, r) {
	let i = e + n, a = t + r;
	return {
		x: Math.min(e, i),
		y: Math.min(t, a),
		width: Math.abs(n),
		height: Math.abs(r)
	};
}
function N(e, t, n, r, i) {
	let a = e - n, o = t - r;
	return a * a + o * o <= i * i;
}
function P(e, t, n, r, i, a, o) {
	if (i === 0) return I(e, t, n, r);
	let s = Math.atan2(t - r, e - n);
	return s < 0 && (s += k), s >= a && s <= o ? (Math.hypot(e - n, t - r) - i) ** 2 : Math.min(I(e, t, n + Math.cos(a) * i, r + Math.sin(a) * i), I(e, t, n + Math.cos(o) * i, r + Math.sin(o) * i));
}
function F(e, t, n, r, i, a) {
	let o = n - e, s = r - t, c = o * o + s * s;
	if (c === 0) return I(i, a, e, t);
	let l = Math.max(0, Math.min(1, ((i - e) * o + (a - t) * s) / c));
	return I(i, a, e + l * o, t + l * s);
}
function I(e, t, n, r) {
	return (e - n) ** 2 + (t - r) ** 2;
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/nearest.js
var ee = /* @__PURE__ */ new WeakMap();
function te(e, t, n, r) {
	let i, a = Infinity;
	for (let r = e.length; r--;) {
		let o = e[r], s = o.x - t, c = o.y - n, l = s * s + c * c;
		l <= a && (i = o, a = l);
	}
	return i && a <= Math.max(0, r) ** 2 ? i : null;
}
function ne(e, t, n, r, i = e.points) {
	let a = ie(e), o = i === e.points ? void 0 : new Set(i);
	if (!a.targets.length && !a.attachedPoints.size) return te(i, t, n, r);
	let s = re(e, t, n, i);
	if (s) return s.point;
	let c, l, u = Infinity, d = Infinity;
	for (let e of a.targets) {
		let r = e.node.interaction;
		if (!se(r, o)) continue;
		let i = r.affinity ?? "xy";
		if (i === "geometry") continue;
		let a = i === "x" ? "x" : i === "y" ? "y" : void 0, s = a ? be(e.bounds, a === "x" ? t : n, a) : le(e, t, n);
		if (s > u) continue;
		let f = a ? le(e, t, n) : s;
		(s < u || s === u && f < d) && (l = r, c = void 0, u = s, d = f);
	}
	if (u !== 0) for (let e of i) {
		if (a.attachedPoints.has(e)) continue;
		let r = e.x - t, i = e.y - n, o = r * r + i * i;
		o < u && (c = e, l = void 0, u = o, d = o);
	}
	return u > Math.max(0, r) ** 2 ? null : c ?? (l ? oe(l, t, n, o) : void 0) ?? null;
}
function re(e, t, n, r = e.points) {
	let i = ie(e), a = r === e.points ? void 0 : new Set(r);
	for (let e = i.targets.length; e--;) {
		let r = i.targets[e];
		if (ye(r.bounds, t, n) && ce(r, t, n)) {
			let e = r.node.interaction, i = oe(e, t, n, a), o = e.point ? !0 : e.points.length > 0;
			if (i || !a || !o) return { point: i };
		}
	}
	return null;
}
function ie(e) {
	let t = ee.get(e);
	if (t) return t;
	let n = [], r = /* @__PURE__ */ new Set();
	ae(e.nodes, 0, 0, void 0, n, r);
	let i = {
		targets: n,
		attachedPoints: r
	};
	return ee.set(e, i), i;
}
function ae(e, t, n, r, i, a) {
	for (let o of e) {
		if (o.kind === "group") {
			if (o.focus) continue;
			let e = t + (o.translateX ?? 0), s = n + (o.translateY ?? 0), c = o.clip ? ge(o.clip, e, s) : void 0, l = r === null ? null : ve(r, c);
			ae(o.children, e, s, l, i, a);
			continue;
		}
		if (o.kind === "label" || !o.interaction) continue;
		if (o.interaction.point) a.add(o.interaction.point);
		else for (let e of o.interaction.points) a.add(e);
		if (r === null) continue;
		let e = ue(o);
		if (!e) continue;
		let s = ge(e, t, n), c = r ? ve(s, r) : s;
		c != null && i.push({
			node: o,
			offsetX: t,
			offsetY: n,
			bounds: c,
			clip: r
		});
	}
}
function oe(e, t, n, r) {
	if (e.point) return !r || r.has(e.point) ? e.point : null;
	let i = e.affinity ?? "xy", a, o = Infinity, s = Infinity;
	for (let c of e.points) {
		if (r && !r.has(c)) continue;
		let e = c.x - t, l = c.y - n, u = e * e + l * l, d = i === "x" ? e * e : i === "y" ? l * l : u;
		(d < o || d === o && u < s) && (a = c, o = d, s = u);
	}
	return a ?? null;
}
function se(e, t) {
	return t ? e.point ? t.has(e.point) : e.points.some((e) => t.has(e)) : !0;
}
function ce(e, t, n) {
	let r = t - e.offsetX, i = n - e.offsetY, { node: a } = e;
	switch (a.kind) {
		case "rect": return a.cornerRadii === void 0 ? de(a, r, i) : A(a.x, a.y, a.width, a.height, a.cornerRadii, r, i);
		case "dot": {
			let e = r - a.x, t = i - a.y, n = Math.max(0, a.radius);
			return e * e + t * t <= n * n;
		}
		case "area": return a.polygons === void 0 ? L(a.points, r, i) : pe(a.polygons, r, i);
		case "polyline": return R(a.points, r, i, !1) <= H(a) ** 2;
		case "rule": return z(a.x1, a.y1, a.x2, a.y2, r, i) <= H(a) ** 2;
	}
}
function le(e, t, n) {
	let r = t - e.offsetX, i = n - e.offsetY, { node: a } = e, o;
	switch (a.kind) {
		case "rect":
			o = a.cornerRadii === void 0 ? a.radius ? fe(a, r, i) : xe(a, r, i) : j(a.x, a.y, a.width, a.height, a.cornerRadii, r, i);
			break;
		case "dot": {
			let e = r - a.x, t = i - a.y, n = Math.max(0, Math.sqrt(e * e + t * t) - Math.max(0, a.radius));
			o = n * n;
			break;
		}
		case "area":
			o = a.polygons === void 0 ? R(a.points, r, i, !0) : me(a.polygons, r, i);
			break;
		case "polyline": {
			let e = R(a.points, r, i, !1), t = Math.max(0, Math.sqrt(e) - H(a));
			o = t * t;
			break;
		}
		case "rule": {
			let e = z(a.x1, a.y1, a.x2, a.y2, r, i), t = Math.max(0, Math.sqrt(e) - H(a));
			o = t * t;
			break;
		}
	}
	return e.clip ? Math.max(o, xe(e.clip, t, n)) : o;
}
function ue(e) {
	switch (e.kind) {
		case "rect": return V(e);
		case "dot": {
			let t = Math.max(0, e.radius);
			return {
				x: e.x - t,
				y: e.y - t,
				width: t * 2,
				height: t * 2
			};
		}
		case "area": return e.polygons === void 0 ? B(e.points) : he(e.polygons);
		case "polyline": {
			let t = B(e.points);
			return t ? _e(t, H(e)) : null;
		}
		case "rule": return _e({
			x: Math.min(e.x1, e.x2),
			y: Math.min(e.y1, e.y2),
			width: Math.abs(e.x2 - e.x1),
			height: Math.abs(e.y2 - e.y1)
		}, H(e));
	}
}
function de(e, t, n) {
	let r = V(e);
	if (!ye(r, t, n)) return !1;
	let i = Math.max(0, Math.min(e.radius ?? 0, r.width / 2, r.height / 2));
	if (i === 0 || t >= r.x + i && t <= r.x + r.width - i || n >= r.y + i && n <= r.y + r.height - i) return !0;
	let a = t < r.x + i ? r.x + i : r.x + r.width - i, o = n < r.y + i ? r.y + i : r.y + r.height - i, s = t - a, c = n - o;
	return s * s + c * c <= i * i;
}
function fe(e, t, n) {
	let r = V(e), i = r.width / 2, a = r.height / 2, o = Math.max(0, Math.min(e.radius ?? 0, i, a)), s = Math.abs(t - (r.x + i)) - (i - o), c = Math.abs(n - (r.y + a)) - (a - o), l = Math.sqrt(Math.max(0, s) ** 2 + Math.max(0, c) ** 2) - o;
	return Math.max(0, l) ** 2;
}
function L(e, t, n) {
	let r = !1;
	for (let i = 0, a = e.length - 1; i < e.length; a = i++) {
		let o = e[i], s = e[a];
		o[1] > n != s[1] > n && t < (s[0] - o[0]) * (n - o[1]) / (s[1] - o[1]) + o[0] && (r = !r);
	}
	return r;
}
function pe(e, t, n) {
	return e.some(([e, ...r]) => !e || !L(e, t, n) ? !1 : !r.some((e) => L(e, t, n)));
}
function me(e, t, n) {
	let r = Infinity;
	for (let i of e) for (let e of i) r = Math.min(r, R(e, t, n, !0));
	return r;
}
function R(e, t, n, r) {
	if (!e.length) return Infinity;
	if (e.length === 1) {
		let r = e[0];
		return (r[0] - t) ** 2 + (r[1] - n) ** 2;
	}
	let i = Infinity, a = r ? e.length : Math.max(0, e.length - 1);
	for (let r = 0; r < a; r += 1) {
		let a = e[r], o = e[(r + 1) % e.length];
		i = Math.min(i, z(a[0], a[1], o[0], o[1], t, n));
	}
	return i;
}
function z(e, t, n, r, i, a) {
	let o = n - e, s = r - t, c = o * o + s * s, l = c ? Math.max(0, Math.min(1, ((i - e) * o + (a - t) * s) / c)) : 0, u = i - (e + l * o), d = a - (t + l * s);
	return u * u + d * d;
}
function B(e) {
	let t = Infinity, n = Infinity, r = -Infinity, i = -Infinity;
	for (let a of e) Number.isFinite(a[0]) && Number.isFinite(a[1]) && (t = Math.min(t, a[0]), n = Math.min(n, a[1]), r = Math.max(r, a[0]), i = Math.max(i, a[1]));
	return Number.isFinite(t) ? {
		x: t,
		y: n,
		width: r - t,
		height: i - n
	} : null;
}
function he(e) {
	return B(e.flatMap((e) => e.flat()));
}
function V(e) {
	return {
		x: Math.min(e.x, e.x + e.width),
		y: Math.min(e.y, e.y + e.height),
		width: Math.abs(e.width),
		height: Math.abs(e.height)
	};
}
function ge(e, t, n) {
	let r = V(e);
	return {
		...r,
		x: r.x + t,
		y: r.y + n
	};
}
function _e(e, t) {
	return {
		x: e.x - t,
		y: e.y - t,
		width: e.width + t * 2,
		height: e.height + t * 2
	};
}
function ve(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = Math.max(e.x, t.x), r = Math.max(e.y, t.y), i = Math.min(e.x + e.width, t.x + t.width), a = Math.min(e.y + e.height, t.y + t.height);
	return i < n || a < r ? null : {
		x: n,
		y: r,
		width: i - n,
		height: a - r
	};
}
function ye(e, t, n) {
	return t >= e.x && t <= e.x + e.width && n >= e.y && n <= e.y + e.height;
}
function be(e, t, n) {
	let r = n === "x" ? e.x : e.y, i = n === "x" ? e.width : e.height, a = t < r ? r - t : t > r + i ? t - r - i : 0;
	return a * a;
}
function xe(e, t, n) {
	let r = V(e), i = t < r.x ? r.x - t : t > r.x + r.width ? t - r.x - r.width : 0, a = n < r.y ? r.y - n : n > r.y + r.height ? n - r.y - r.height : 0;
	return i * i + a * a;
}
function H(e) {
	return Math.max(0, e.style?.strokeWidth ?? 1) / 2;
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/focus-coordinate-internal.js
var U = /* @__PURE__ */ new WeakMap();
function Se(e, t, n) {
	let r = U.get(e);
	r ? r[t] = n : U.set(e, { [t]: n });
}
function Ce(e, t) {
	return U.get(e)?.[t] ?? e[t];
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/materialized-channel-internal.js
var we = /* @__PURE__ */ Symbol();
function Te(e, t) {
	return e === "x" || e === "y" ? e : t[we];
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scene-point-map.js
function Ee(e, t) {
	return ["x", "y"].some((n) => (e.scales[n]?.viewport?.translate ?? 0) !== (t.scales[n]?.viewport?.translate ?? 0));
}
function De(e, t) {
	return e.map((e) => e.kind === "group" ? {
		...e,
		children: De(e.children, t),
		...e.focus ? { focus: {
			...e.focus,
			points: e.focus.points.map(t)
		} } : {},
		...e.states ? { states: {
			...e.states,
			points: e.states.points.map(t)
		} } : {}
	} : e.kind === "label" || !e.interaction ? e : {
		...e,
		interaction: e.interaction.point ? {
			...e.interaction,
			point: t(e.interaction.point)
		} : {
			...e.interaction,
			points: e.interaction.points.map(t)
		}
	});
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scene-source.js
var Oe = /* @__PURE__ */ Symbol("chart-scene-source"), ke = /* @__PURE__ */ Symbol("default-focus-layer");
function Ae(e) {
	return e.focus && Object.assign(e.focus, { [ke]: !0 }), e;
}
function je(e) {
	return e.focus?.[ke] === !0;
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scene.js
var W = {
	foreground: "currentColor",
	muted: "currentColor",
	grid: "currentColor",
	background: "transparent",
	palette: [
		"var(--ts-chart-1, #2563eb)",
		"var(--ts-chart-2, #f97316)",
		"var(--ts-chart-3, #10b981)",
		"var(--ts-chart-4, #8b5cf6)",
		"var(--ts-chart-5, #ec4899)",
		"var(--ts-chart-6, #06b6d4)"
	]
};
function Me(e, t) {
	return t ? typeof e == "function" ? {
		chart: e,
		...t
	} : {
		...e,
		...t
	} : typeof e == "function" ? { chart: e } : e;
}
function Ne(e, t, n = {}) {
	return Fe(e, t, (e) => {
		if (!e.options?.scale) throw TypeError(`Chart scale "${e.id}" requires a configured scale`);
		return Pe(e.options.scale, e);
	}, n);
}
function Pe(e, t) {
	if (typeof e == "function") return c(e, t);
	if (t.options?.viewport) throw TypeError(`Chart viewport "${t.id}" requires a configured or inferable continuous scale`);
	return e.resolve(t);
}
function Fe(e, t, n, r) {
	let a = gt(t.width), o = gt(t.height), s = {
		...r,
		measureText: i(r.measureText, r.typography)
	}, c = {
		...W,
		...s.defaultTheme,
		palette: s.defaultTheme?.palette ?? W.palette
	}, l = {
		...c,
		...e.theme,
		palette: e.theme?.palette ?? c.palette
	}, u = e.marks.map((e, t) => e.initialize({ markIndex: t })), { margin: d, chart: f, scales: p, axes: m, marks: h, colors: g, legend: _, legendBounds: v, positionScales: y, scaleGuides: b, gridScales: x } = Ye(e, u, a, o, l, Ke(e, Ge(u)), n, s), S = [], C = [], w = [], T = [], E = h.findIndex((e) => !e.focus && !e.focusGuideOnly);
	h.forEach((e, t) => {
		let n = Le(e, "x", y, p), r = Le(e, "y", y, p), i = n !== void 0, c = r !== void 0, u = /* @__PURE__ */ new Map(), d = (t) => {
			let a = u.get(t);
			if (a) return a;
			let o = i || c ? {
				...t,
				x: t.x + (n ?? 0),
				y: t.y + (r ?? 0)
			} : t;
			return Ie(o, e, p, n, r), u.set(t, o), o;
		}, m = e.render({
			markIndex: t,
			surface: {
				x: 0,
				y: 0,
				width: a,
				height: o
			},
			chart: f,
			scales: p,
			theme: l,
			color: g.map,
			colors: g,
			layout: s
		});
		_?.filterMark && (m = _.filterMark(m, { seriesFromColor: e.seriesFromColor })), e.postDomain && (m = e.postDomain(m));
		let h = Ue(m.nodes, m.points), v = i || c ? De(m.nodes, d) : m.nodes, b = h.map(d), x = [], D = E < 0 || t < E ? "under" : "over";
		for (let e of m.focusGuides ?? []) T.push({
			...e,
			placement: e.placement ?? D
		});
		if (e.focus) {
			let t = e.focus.retarget === !0;
			x.push({
				kind: "group",
				key: `focus:${e.id}`,
				className: "ts-chart__focus-layer",
				ariaHidden: !0,
				focus: {
					markId: e.id,
					match: e.focus.match ?? "primary",
					anchors: m.focusAnchors ?? h,
					points: b,
					placement: D,
					...t ? {
						retarget: !0,
						candidates: v
					} : {}
				},
				children: t ? [] : v
			});
		} else {
			let t = b;
			if (e.states) x.push({
				kind: "group",
				key: `states:${e.id}`,
				children: v,
				states: {
					data: e.states.data,
					definitions: e.states.definitions,
					points: t
				}
			});
			else for (let e of v) x.push(e);
			for (let e of t) w.push(e);
			t.length && C.push({
				markId: e.id,
				points: t,
				clipped: i || c
			});
		}
		S.push({
			key: e.id,
			nodes: x,
			translateX: n,
			translateY: r
		});
	});
	let D = ze(S, f), O = [{
		kind: "group",
		key: "marks",
		className: "ts-chart__marks",
		clip: e.clip ? f : void 0,
		children: D
	}];
	x.length && O.unshift(at(f, x, l)), b.length && O.push(m);
	let k = [], A = /* @__PURE__ */ new Set();
	for (let t of e.controls ?? []) {
		if (!t.id.trim()) throw TypeError("Chart control ids must be nonempty");
		if (A.has(t.id)) throw TypeError(`Duplicate chart control id "${t.id}"`);
		A.add(t.id);
		let e = t.resolve({
			chart: f,
			scales: p,
			colors: g,
			theme: l,
			width: a,
			height: o
		});
		e.nodes && O.push(...e.nodes), e.controls && k.push(...e.controls);
	}
	if (_ && v) {
		let e = {
			colors: g,
			chart: f,
			bounds: v,
			theme: l,
			layout: s,
			width: a,
			height: o,
			direction: s.typography?.direction
		};
		O.push(_.render(e)), _.control && k.push(_.control(e));
	}
	let j = /* @__PURE__ */ new Set();
	for (let e of k) {
		let t = `${e.extension.id}:${e.key}`;
		if (j.has(t)) throw TypeError(`Duplicate chart host control "${t}"`);
		j.add(t);
	}
	let M = e.focusRing ?? l.focusRing;
	if (e.focus !== !1 && M !== !1 && w.length) {
		let e = typeof M == "object" ? M : void 0, t = rt(e?.radius, 5), n = e?.fill ?? "var(--ts-chart-focus-fill, Canvas)", r = e?.stroke, i = rt(e?.strokeWidth, 2.5);
		for (let e of C) O.push(Ae({
			kind: "group",
			key: `default-focus:${e.markId}`,
			className: "ts-chart__focus-layer ts-chart__focus-layer--default",
			ariaHidden: !0,
			clip: e.clipped ? f : void 0,
			focus: {
				match: "primary",
				anchors: e.points,
				points: e.points,
				placement: "over"
			},
			children: e.points.map((e) => ({
				kind: "dot",
				key: e.key,
				x: e.x,
				y: e.y,
				radius: t,
				style: {
					fill: n,
					stroke: r ?? e.color,
					strokeWidth: i
				}
			}))
		}));
	}
	return {
		width: a,
		height: o,
		margin: d,
		chart: f,
		nodes: O,
		points: w,
		scales: p,
		colors: g,
		gradients: e.gradients ?? [],
		theme: l,
		...s.typography?.direction === void 0 ? {} : { direction: s.typography.direction },
		...k.length ? { controls: k } : {},
		...T.length ? { focusGuides: T } : {},
		[Oe]: [e, u]
	};
}
function Ie(e, t, n, r, i) {
	a("x", e.xValue, e.x, r), a("y", e.yValue, e.y, i);
	function a(r, i, a, o) {
		let s = t.channels[r]?.scale, c = s === void 0 ? void 0 : n[s];
		if (!c || c.type === "none") return;
		let l = c.map(i) + (o ?? 0);
		Number.isFinite(l) && l !== a && Se(e, r, l);
	}
}
function Le(e, t, n, r) {
	let i = e.viewport?.[t];
	if (i !== "fixed") {
		for (let r of n) if (r.channel === t && r.scale.viewport && Object.values(e.channels).some((e) => e.scale === r.id)) return r.scale.viewport.translate;
		return i === "content" ? r[t]?.viewport?.translate : void 0;
	}
}
function Re(e, t) {
	return ["x", "y"].some((n) => t.some((t) => t.channel === n && t.scale.viewport && e.viewport?.[n] !== "fixed" && (e.viewport?.[n] === "content" || Object.values(e.channels).some((e) => e.scale === t.id))));
}
function ze(e, t) {
	return e.flatMap((e) => e.translateX === void 0 && e.translateY === void 0 ? [...e.nodes] : [{
		kind: "group",
		key: `viewport-clip:${e.key}`,
		className: "ts-chart__viewport-clip",
		clip: t,
		children: [{
			kind: "group",
			key: `viewport-content:${e.key}`,
			className: "ts-chart__viewport-content",
			...e.translateX === void 0 ? {} : { translateX: e.translateX },
			...e.translateY === void 0 ? {} : { translateY: e.translateY },
			children: e.nodes
		}]
	}]);
}
function Be(e, t, n, r = Infinity, i = e.points) {
	return ne(e, t, n, r, i);
}
function Ve(e, t = e.points) {
	if (!Object.values(e.scales).some((e) => e.viewport)) return t;
	let { x: n, y: r, width: i, height: a } = e.chart, o = n + i, s = r + a, c = t.filter((t) => !He(e, t) || t.x >= n && t.x <= o && t.y >= r && t.y <= s);
	return c.length === t.length ? t : c;
}
function He(e, t) {
	let n = e[Oe]?.[1].find((e) => e.id === t.markId);
	return !n || ["x", "y"].some((t) => {
		let r = n.viewport?.[t];
		return r === "fixed" ? !1 : r === "content" && e.scales[t]?.viewport ? !0 : Object.entries(n.channels).some(([n, r]) => n === t && r.scale !== void 0 && e.scales[r.scale]?.viewport !== void 0);
	});
}
function Ue(e, t) {
	let n = t ? [...t] : [], r = new Set(n), i = (e) => {
		for (let t of e) {
			if (t.kind === "group") {
				t.focus || i(t.children);
				continue;
			}
			if (t.kind === "label" || !t.interaction) continue;
			let e = t.interaction;
			if (e.point) r.has(e.point) || (r.add(e.point), n.push(e.point));
			else for (let t of e.points) r.has(t) || (r.add(t), n.push(t));
		}
	};
	return i(e), n;
}
function We(e, t) {
	let n = [], r = !1, i = !1;
	for (let a of e) for (let e of Object.values(a.channels)) if (e.scale === t) {
		i = !0;
		for (let t of e.values) n.push(t);
		r ||= e.includeZero ?? !1;
	}
	return {
		values: n,
		includeZero: r,
		materialized: i
	};
}
function Ge(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) for (let [e, r] of Object.entries(n.channels)) {
		let i = r.scale;
		if (i === void 0) continue;
		let a = Te(e, r);
		if (i === "color") {
			if (a) throw TypeError("Position scales cannot use reserved ID \"color\"");
			continue;
		}
		let o = t.get(i) ?? {
			values: [],
			includeZero: !1,
			materialized: !1
		};
		if (a && o.channel && o.channel !== a) throw TypeError(`Chart scale "${i}" cannot materialize both x and y channels`);
		o.channel ??= a, o.materialized ||= !n.focusGuideOnly, o.includeZero ||= r.includeZero ?? !1;
		for (let e of r.values) o.values.push(e);
		t.set(i, o);
	}
	return t;
}
function Ke(e, t) {
	let n = e.scales;
	if (!n || !Object.hasOwn(n, "x") || !Object.hasOwn(n, "y")) throw TypeError("Chart scales must define reserved `x` and `y` entries");
	for (let e of t.keys()) if (!Object.hasOwn(n, e)) throw TypeError(`Chart scale "${e}" is used by a mark but is not configured`);
	return Object.entries(n).map(([e, n]) => {
		if (e === "color") throw TypeError("Position scales cannot use reserved ID \"color\"");
		let r = t.get(e) ?? {
			values: [],
			includeZero: !1,
			materialized: !1
		}, i = e === "x" || e === "y" ? e : void 0, a = n?.channel;
		if (!i && n !== null && !a) throw TypeError(`Named chart scale "${e}" requires channel: "x" or channel: "y"`);
		let o = i ?? a ?? r.channel ?? "x";
		if (a && a !== o || r.channel && r.channel !== o) throw TypeError(`Chart scale "${e}" is configured for ${o} but is used as ${r.channel ?? a}`);
		let s = n?.side ?? (o === "x" ? "bottom" : "left");
		if (o === "x" && s !== "top" && s !== "bottom" || o === "y" && s !== "left" && s !== "right") throw TypeError(`Chart scale "${e}" uses ${o} and cannot render an axis on the ${s} side`);
		return {
			id: e,
			channel: o,
			side: s,
			options: n,
			channels: r
		};
	});
}
var G = 4, qe = 4, Je = .25;
function Ye(e, t, n, i, a, o, c, l) {
	let u = tt(e.margin), d = q(Y(e.guides !== !1 && o.some(Xe) ? G : 0), u), f = d;
	for (let e = 0; e < qe; e += 1) {
		let e = h(d), t = g(e);
		if (f = q(t, u, f), nt(d, t)) return e;
		d = t;
	}
	let p = h(f), m = q(g(p), u, f);
	return nt(f, m) || (p = h(m)), p;
	function h(u) {
		let d = {
			x: u.left,
			y: u.top,
			width: Math.max(1, n - u.left - u.right),
			height: Math.max(1, i - u.top - u.bottom)
		}, f = {}, p = [];
		for (let e of o) {
			let { id: t, channel: n, options: r, channels: i } = e, a = ct(r, n === "x" ? d.width : d.height, n === "x" ? 92 : 48, n === "x" ? 8 : 7), o = n === "x" ? [d.x, d.x + d.width] : [d.y + d.height, d.y], s = r == null ? it(t, i.materialized, r) : c({
				id: t,
				channel: n,
				values: i.values,
				range: o,
				options: r,
				tickCount: a,
				includeZero: i.includeZero
			});
			f[t] = s, p.push({
				...e,
				scale: s
			});
		}
		let m = Qe(t, {
			chart: d,
			scales: f,
			theme: a,
			layout: l
		}), h = We(m, "color"), g = s(h.values, e.color, a);
		if (g.kind !== "categorical" && m.some((e) => e.seriesFromColor)) throw TypeError("A continuous color channel cannot infer series identity; supply z explicitly");
		let _ = g.domain.length ? e.color?.legend : void 0;
		if (_?.seriesVisible && g.kind !== "categorical") throw TypeError("An interactive color legend requires a categorical color scale");
		let v = _?.height(g.domain.length, {
			colors: g,
			chart: d,
			bounds: {
				x: d.x,
				y: 0,
				width: d.width,
				height: 0
			},
			theme: a,
			layout: l,
			width: n,
			height: i,
			direction: l.typography?.direction
		}), y = _ && v !== void 0 ? {
			x: d.x,
			y: _.placement === "bottom" ? i - v : 0,
			width: d.width,
			height: v
		} : void 0, b = e.guides === !1 ? [] : p.filter(Xe), x = e.guides === !1 ? [] : p.filter(Ze), S = ot(d, b, a, n, l.measureText, l.typography?.direction === "rtl");
		return x.length && r(S.margin, at(d, x, a), d), {
			margin: u,
			chart: d,
			scales: f,
			axes: S.axes,
			positionScales: p,
			scaleGuides: b,
			gridScales: x,
			guideMargin: S.margin,
			marks: m,
			colors: g,
			legend: _,
			legendBounds: y
		};
	}
	function g(t) {
		let r = t.guideMargin;
		if (t.legend) {
			let e = t.legend.height(t.colors.domain.length, {
				colors: t.colors,
				chart: t.chart,
				bounds: {
					x: t.chart.x,
					y: 0,
					width: t.chart.width,
					height: 0
				},
				theme: a,
				layout: l,
				width: n,
				height: i,
				direction: l.typography?.direction
			});
			t.legend.placement === "bottom" ? u.bottom === void 0 && (r.bottom += e) : u.top === void 0 && (r.top = Math.max(r.top, e));
		}
		return e.clip || t.marks.forEach((e, o) => {
			if (Re(e, t.positionScales)) return;
			let s = e.layoutLabels?.({
				markIndex: o,
				surface: {
					x: 0,
					y: 0,
					width: n,
					height: i
				},
				chart: t.chart,
				scales: t.scales,
				theme: a,
				color: t.colors.map,
				colors: t.colors,
				layout: l
			});
			for (let e of s ?? []) $e(r, t.chart, e, l.measureText);
		}), q(r, u);
	}
}
function Xe(e) {
	return e.options != null && e.options.axis !== !1;
}
function Ze(e) {
	return e.options != null && !!e.options.grid;
}
function Qe(e, t) {
	return e.map((e, n) => {
		if (typeof e.resolveLayout != "function") return e;
		let r = e.resolveLayout({
			...t,
			markIndex: n
		});
		return {
			id: e.id,
			channels: r.channels ?? e.channels,
			viewport: e.viewport,
			focusGuideOnly: e.focusGuideOnly,
			seriesFromColor: e.seriesFromColor,
			focus: e.focus,
			states: r.states ?? e.states,
			postDomain: r.postDomain ?? e.postDomain,
			layoutLabels: r.layoutLabels ?? e.layoutLabels,
			render: r.render
		};
	});
}
function $e(e, t, r, i) {
	let a = n(r, i);
	return r.text && et(e, t, a), a;
}
function et(e, t, n) {
	e.top = Math.max(e.top, t.y - n.y + G), e.right = Math.max(e.right, n.x + n.width - t.x - t.width + G), e.bottom = Math.max(e.bottom, n.y + n.height - t.y - t.height + G), e.left = Math.max(e.left, t.x - n.x + G);
}
function tt(e) {
	if (typeof e == "number") return Y(J(e));
	if (!e) return {};
	let t = {};
	for (let n of K) e[n] !== void 0 && (t[n] = J(e[n]));
	return t;
}
var K = [
	"top",
	"right",
	"bottom",
	"left"
];
function q(e, t, n) {
	let r = { ...e };
	for (let i of K) r[i] = t[i] ?? (n ? Math.max(n[i], e[i]) : e[i]);
	return r;
}
function nt(e, t) {
	return K.every((n) => Math.abs(e[n] - t[n]) <= Je);
}
function J(e) {
	return e !== void 0 && Number.isFinite(e) ? Math.max(0, e) : 0;
}
function rt(e, t) {
	return e !== void 0 && Number.isFinite(e) && e >= 0 ? e : t;
}
function Y(e) {
	return {
		top: e,
		right: e,
		bottom: e,
		left: e
	};
}
function it(e, t, n) {
	if (t) throw TypeError(n === null ? `Chart scale "${e}" cannot be null when a mark materializes its channel` : `Chart scale "${e}" requires a configured scale when a mark materializes its channel`);
	return {
		id: e,
		type: "none",
		domain: [],
		map: () => {
			throw TypeError(`Chart scale "${e}" is not configured`);
		},
		ticks: [],
		bandwidth: 0
	};
}
function at(e, t, n) {
	let r = [];
	for (let n of t) {
		if (!n.options?.grid) continue;
		let t = st(n.options.grid);
		for (let i of n.scale.ticks) {
			let a = `${n.id}-grid:${o(i.value)}`;
			r.push(n.channel === "x" ? {
				kind: "rule",
				key: a,
				x1: i.position,
				x2: i.position,
				y1: e.y,
				y2: e.y + e.height,
				...t ? { style: t } : {}
			} : {
				kind: "rule",
				key: a,
				x1: e.x,
				x2: e.x + e.width,
				y1: i.position,
				y2: i.position,
				...t ? { style: t } : {}
			});
		}
	}
	return {
		kind: "group",
		key: "grid",
		className: "ts-chart__grid",
		ariaHidden: !0,
		children: r,
		style: {
			stroke: n.grid,
			strokeOpacity: .11,
			strokeWidth: 1
		}
	};
}
function ot(e, t, i, a, s, c = !1) {
	let l = [], u = Y(t.length ? G : 0), d = {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	}, f = {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	}, p = e.x + e.width, m = e.y + e.height;
	for (let n of t) {
		let t = X(Z(n.options)?.line), r = d[n.side] + (f[n.side] > 0 ? t : 0);
		u[n.side] = Math.max(u[n.side], r + G);
		let i = n.side === "top" ? e.y - r : n.side === "right" ? p + r : n.side === "bottom" ? m + r : e.x - r, a = i, o = (t) => {
			et(u, e, t), a = n.side === "top" ? Math.min(a, t.y) : n.side === "right" ? Math.max(a, t.x + t.width) : n.side === "bottom" ? Math.max(a, t.y + t.height) : Math.min(a, t.x);
		}, s = (e) => {
			a = n.side === "top" || n.side === "left" ? Math.min(a, e) : Math.max(a, e);
		};
		n.channel === "x" ? g(n, i, o, s) : _(n, i, o, s);
		let c = n.side === "top" ? e.y - a : n.side === "right" ? a - p : n.side === "bottom" ? a - m : e.x - a;
		d[n.side] = Math.max(r, c) + 8, f[n.side] += 1;
	}
	let h = {
		kind: "group",
		key: "axes",
		className: "ts-chart__axes",
		ariaHidden: !0,
		children: l
	};
	return r(u, h, e), {
		axes: h,
		margin: u
	};
	function g(t, r, u, d) {
		let f = Z(t.options), m = t.side === "bottom", h = m ? 1 : -1;
		f?.line !== !1 && (l.push({
			kind: "rule",
			key: `${t.id}-axis`,
			x1: e.x,
			x2: p,
			y1: r,
			y2: r,
			style: v(f?.line)
		}), d(r + h * X(f?.line)));
		let g = f?.ticks === !1 ? [] : t.scale.ticks, _ = f?.ticks && f.ticks.line, y = J(f?.ticks === !1 || _ === !1 ? 0 : f?.ticks?.size ?? 4), b = J(f?.ticks === !1 ? 0 : f?.ticks?.padding ?? 4), x = lt(f), S = x === !1 ? [] : dt(t, ut(t.scale, t.options, x), r, y, b, x, a, i, s, c), C = x === !1 ? [] : ft(S, x, t.scale.type === "band"), w = r;
		for (let e of g) {
			if (y <= 0) continue;
			let n = r + h * y;
			d(n), w = m ? Math.max(w, n) : Math.min(w, n), l.push({
				kind: "rule",
				key: `${t.id}-tick-rule:${o(e.value)}`,
				x1: e.position,
				x2: e.position,
				y1: r,
				y2: n,
				style: v(_)
			});
		}
		for (let e of C) u(e.bounds), w = m ? Math.max(w, e.bounds.y + e.bounds.height) : Math.min(w, e.bounds.y), l.push(e.label);
		let T = f?.label, E = typeof T == "string" ? T : T?.text;
		if (!E) return;
		let D = typeof T == "object" ? T : void 0, O = D?.offset ?? "auto", k = O !== "auto", A = {
			kind: "label",
			key: `${t.id}-label`,
			x: e.x + e.width / 2,
			y: k ? r + h * Math.max(0, J(O)) : w + h * 8,
			text: E,
			anchor: "middle",
			baseline: m && !k ? "hanging" : "auto",
			fontSize: D?.fontSize ?? (a < 360 ? 10 : 11),
			fontWeight: D?.fontWeight ?? 600,
			style: {
				fill: D?.fill ?? i.foreground,
				...D?.opacity === void 0 ? { fillOpacity: .76 } : { opacity: D.opacity }
			}
		};
		u(n(A, s)), l.push(A);
	}
	function _(t, r, u, d) {
		let f = Z(t.options), p = t.side === "right", h = p ? 1 : -1;
		f?.line !== !1 && (l.push({
			kind: "rule",
			key: `${t.id}-axis`,
			x1: r,
			x2: r,
			y1: e.y,
			y2: m,
			style: v(f?.line)
		}), d(r + h * X(f?.line)));
		let g = f?.ticks === !1 ? [] : t.scale.ticks, _ = f?.ticks && f.ticks.line, y = J(f?.ticks === !1 || _ === !1 ? 0 : f?.ticks?.size ?? 4), b = J(f?.ticks === !1 ? 0 : f?.ticks?.padding ?? 4), x = lt(f), S = x === !1 ? [] : dt(t, ut(t.scale, t.options, x), r, y, b, x, a, i, s, c), C = x === !1 ? [] : ft(S, x, !1), w = r;
		for (let e of g) {
			if (y <= 0) continue;
			let n = r + h * y;
			d(n), w = p ? Math.max(w, n) : Math.min(w, n), l.push({
				kind: "rule",
				key: `${t.id}-tick-rule:${o(e.value)}`,
				x1: r,
				x2: n,
				y1: e.position,
				y2: e.position,
				style: v(_)
			});
		}
		for (let e of C) u(e.bounds), w = p ? Math.max(w, e.bounds.x + e.bounds.width) : Math.min(w, e.bounds.x), l.push(e.label);
		let T = f?.label, E = typeof T == "string" ? T : T?.text;
		if (!E) return;
		let D = typeof T == "object" ? T : void 0, O = {
			kind: "label",
			key: `${t.id}-label`,
			x: r,
			y: e.y + e.height / 2,
			text: E,
			anchor: "middle",
			baseline: "middle",
			rotate: p ? 90 : -90,
			fontSize: D?.fontSize ?? 11,
			fontWeight: D?.fontWeight ?? 600,
			style: {
				fill: D?.fill ?? i.foreground,
				...D?.opacity === void 0 ? { fillOpacity: .76 } : { opacity: D.opacity }
			}
		}, k = D?.offset ?? "auto";
		if (k !== "auto") O.x = r + h * Math.max(0, J(k));
		else {
			let e = n({
				...O,
				x: 0,
				y: 0
			}, s);
			O.x = p ? w + 8 - e.x : w - 8 - (e.x + e.width);
		}
		u(n(O, s)), l.push(O);
	}
	function v(e) {
		return {
			stroke: i.foreground,
			strokeOpacity: .28,
			...st(e) ?? {}
		};
	}
}
function st(e) {
	if (!e || typeof e != "object") return;
	let t = {};
	return e.stroke !== void 0 && (t.stroke = e.stroke), e.strokeOpacity !== void 0 && (t.strokeOpacity = e.strokeOpacity), e.strokeWidth !== void 0 && (t.strokeWidth = e.strokeWidth), e.strokeDasharray !== void 0 && (t.strokeDasharray = e.strokeDasharray), e.lineCap !== void 0 && (t.lineCap = e.lineCap), Object.keys(t).length ? t : void 0;
}
function X(e) {
	if (!e || typeof e != "object" || e.stroke === "none") return 0;
	let t = e.strokeWidth;
	return t !== void 0 && Number.isFinite(t) && t > 0 ? t / 2 : 0;
}
function ct(e, t, n, r) {
	let i = e?.axis === !1 ? void 0 : e?.axis?.ticks;
	if (i === !1) return Math.max(2, Math.min(r, Math.floor(t / n)));
	let a = i ?? {};
	if ([
		a.count !== void 0,
		a.spacing !== void 0,
		a.values !== void 0
	].filter(Boolean).length > 1) throw TypeError("Axis ticks accept only one candidate policy: count, spacing, or values");
	if (a.values) return Math.max(1, a.values.length);
	if (a.count !== void 0) return Math.max(1, Math.floor(J(a.count)));
	if (a.spacing !== void 0) {
		let e = Math.max(1, J(a.spacing));
		return Math.max(1, Math.floor(t / e));
	}
	return Math.max(2, Math.min(r, Math.floor(t / n)));
}
function Z(e) {
	if (e && e.axis !== !1) return e.axis ?? {};
}
function lt(e) {
	return e?.ticks === !1 || e?.tickLabels === !1 ? !1 : e?.tickLabels ?? {};
}
function ut(e, t, n) {
	let r = (typeof n.thin == "object" ? n.thin : void 0)?.keep ?? [];
	if (!r.length) return e.ticks;
	let i = t?.axis === !1 || t?.axis?.ticks === !1 ? void 0 : t?.axis?.ticks?.format, a = e.ticks.map((e) => ({
		...e,
		hard: r.some((t) => o(t) === o(e.value))
	})), s = new Set(a.map((e) => o(e.value)));
	for (let t of r) {
		let n = e.map(t);
		!s.has(o(t)) && Number.isFinite(n) && a.push({
			value: t,
			position: n,
			label: i?.(t) ?? ht(t),
			hard: !0
		});
	}
	return a;
}
function dt(e, r, i, a, s, c, l, u, d, f = !1) {
	let p = l < 360 ? 10 : 11, m = e.side === "bottom" || e.side === "right", h = m ? 1 : -1;
	return r.map((r, l) => {
		let g = {
			value: r.value,
			index: l,
			position: r.position,
			bandwidth: e.scale.bandwidth
		}, _ = c.rotate, v = Q(c.fontSize, g) ?? p, y = Q(c.fontWeight, g), b = c.opacity, x = Q(b, {
			...g,
			focus: null,
			pointer: null
		}), S = Q(c.dx, g) ?? 0, C = Q(c.dy, g) ?? 0, w = e.channel === "y" ? t(m ? "left" : "right", f ? "rtl" : "ltr") : (_ ?? 0) < 0 ? t("right", f ? "rtl" : "ltr") : (_ ?? 0) > 0 ? t("left", f ? "rtl" : "ltr") : "middle", T = Q(c.anchor, g) ?? w, E = e.channel === "x", D = {
			kind: "label",
			key: `${e.id}-tick-label:${o(r.value)}`,
			x: E ? r.position + S : i + h * (a + s) + S,
			y: E ? i + h * (a + s + v * .8) + C : r.position + C,
			text: r.label,
			anchor: T,
			rotate: _,
			fontSize: v,
			fontWeight: y,
			style: {
				fill: u.muted,
				...x === void 0 ? { fillOpacity: .68 } : { opacity: x }
			}
		};
		return E || (D.baseline = "middle"), typeof b == "function" && (D.focusOpacity = (e) => b({
			...g,
			...e
		})), {
			value: r.value,
			label: D,
			bounds: n(D, d),
			hard: r.hard ?? !1
		};
	});
}
function Q(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function ft(e, t, n) {
	if (t.thin === !1 || e.length < 2) return [...e];
	let r = typeof t.thin == "object" ? t.thin : {}, i = Math.max(0, J(r.minGap ?? 4)), a = e.filter((e) => e.hard), o = e.filter((e) => !e.hard);
	if ((r.priority === "ends" || n) && o.length) {
		let e = o[0], t = o.at(-1);
		$(e, a, i) || a.push(e), t !== e && !$(t, a, i) && a.push(t);
	}
	let s = pt(o.filter((e) => !a.includes(e)));
	for (let e of s) $(e, a, i) || a.push(e);
	let c = new Set(a);
	return e.filter((e) => c.has(e));
}
function pt(e) {
	if (e.length < 3) return [...e];
	let t = [], n = [e];
	for (; n.length;) {
		let e = n.shift();
		if (!e.length) continue;
		let r = Math.floor(e.length / 2);
		t.push(e[r]), n.push(e.slice(0, r), e.slice(r + 1));
	}
	return t;
}
function $(e, t, n) {
	return t.some((t) => mt(e.bounds, t.bounds, n));
}
function mt(e, t, n) {
	return !(e.x + e.width + n <= t.x || t.x + t.width + n <= e.x || e.y + e.height + n <= t.y || t.y + t.height + n <= e.y);
}
function ht(e) {
	return e instanceof Date ? e.toLocaleDateString() : String(e);
}
function gt(e) {
	return Number.isFinite(e) ? Math.max(1, e) : 1;
}
export { Ve as a, Ce as c, C as d, Be as i, re as l, W as n, je as o, Me as r, Ee as s, Ne as t, te as u };

//# sourceMappingURL=scene-8VKOJsMP.js.map